import React from 'react';

import { defineMessages } from 'react-intl';

import { useAssets } from '~/techstyle-shared/react-assets';
import { useBreakpoint } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import {
  ASSET_CONTAINER_MOBILE,
  ASSET_CONTAINER_DESKTOP,
  ModalContainer,
  BackgroundImageWrapper,
  BackgroundFallback,
  BackgroundImage,
  BackgroundGradient,
  ContentWrapper,
  HeaderText,
  SubText,
  CTAButton,
  LegalSection,
  LegalText,
} from './SunbitModalContent.styles';

const messages = defineMessages({
  title: {
    id: 'branded_credit_card_modal.title_ita',
    defaultMessage: 'Good News, {firstName}!',
  },
  subtext: {
    id: 'branded_credit_card_modal.subtext_ita',
    defaultMessage: 'You are eligible for the Fab Credit Card offer.',
  },
  cta: {
    id: 'branded_credit_card_modal.cta_ita',
    defaultMessage: 'Apply',
  },
  legal: {
    id: 'branded_credit_card_modal.legal_ita',
    defaultMessage:
      '"Terms and restrictions apply. The Fabletics credit card is issued by Transportation Alliance Bank Inc., dba TAB Bank, pursuant to a license from Visa U.S.A. Inc. Click for more details."',
  },
});

interface ITAModalContentProps {
  firstName?: string;
  onCTAClick?: () => void;
}

export default function ITAModalContent({
  firstName,
  onCTAClick,
}: ITAModalContentProps) {
  const { isMobile } = useBreakpoint();

  const assetsData = useAssets([
    ASSET_CONTAINER_MOBILE,
    ASSET_CONTAINER_DESKTOP,
  ]);

  const mobileAsset = assetsData?.find(
    (asset) => asset.name === ASSET_CONTAINER_MOBILE
  );
  const desktopAsset = assetsData?.find(
    (asset) => asset.name === ASSET_CONTAINER_DESKTOP
  );

  const assetData = isMobile ? mobileAsset?.data : desktopAsset?.data;
  const asset = assetData?.assets?.[0];

  const handleCTAClick = () => {
    if (onCTAClick) {
      onCTAClick();
    }
  };

  const renderBackground = () => {
    if (!asset) {
      return <BackgroundFallback />;
    }
    return <BackgroundImage asset={asset} />;
  };

  return (
    <ModalContainer>
      <BackgroundImageWrapper>
        {renderBackground()}
        <BackgroundGradient />
      </BackgroundImageWrapper>

      <ContentWrapper>
        <HeaderText>
          <FormattedMessage
            {...messages.title}
            values={{ firstName: firstName || '' }}
          />
        </HeaderText>
        <SubText>
          <FormattedMessage {...messages.subtext} />
        </SubText>
        <CTAButton onClick={handleCTAClick} data-autotag="SunbitCTAButton">
          <FormattedMessage {...messages.cta} />
        </CTAButton>
        <LegalSection>
          <LegalText>
            <FormattedMessage {...messages.legal} />
          </LegalText>
        </LegalSection>
      </ContentWrapper>
    </ModalContainer>
  );
}
